import { useDispatch, useSelector, TypedUseSelectorHook } from "react-redux";
import {AppStoreDispatch, RootState} from "../store/store";


export const useAppDispatch = useDispatch<AppStoreDispatch>;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;